module.exports = __webpack_public_path__ + "img/background_213.efa28954.png";